import script from "./CompanyQualifications.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyQualifications.vue?vue&type=script&setup=true&lang=js"

import "./CompanyQualifications.vue?vue&type=style&index=0&id=26fe1094&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26fe1094"]])

export default __exports__